import { render } from "./foto.vue?vue&type=template&id=761d69f4"
import script from "./foto.vue?vue&type=script&lang=js"
export * from "./foto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QCard,QImg,QCardActions,QBtn,QDialog,QCardSection,QSeparator});qInstall(script, 'directives', {ClosePopup});
